<template>
    <TextInput
        :label="this.label"
        v-model="this.localModelValue"
        :v="this.v"
        type="date"
        :min="this.min"
        :max="this.max"
    />
</template>

<script>
    import TextInput from '@/components/TextInput.vue';

    export default {
        props: {
            label: {
                required: true
            },
            v: {
                required: true,
            },
            modelValue: {
                required: true,
            },
            min: {
                default: '',
            },
            max: {
                default: '',
            },
        },
        components: {            
            TextInput,
        },
        computed: {
            localModelValue: {
                get() {
                    return this.modelValue
                },
                set(newValue) {
                    this.$emit('update:modelValue', newValue)
                },
            },
        },
        emits: ['update:modelValue'],
        methods: {
        }
    }
</script>
